WL.AttachmentRepeater = new Class({

    Extends: TS.domain.RepeaterEditDomain,

    hookDocument: function () {
        var me = this,
            cmd_ViewAttachment, 
            cmd_UploadDocument,
            cmd_DeleteAttachment,
            cmd_InfoDocument,
            owner = me.ParentDomain;

        cmd_ViewAttachment = me.getCommand('ViewAttachment');
        cmd_ViewAttachment.Text(me.Document().SharepointFileName());
        cmd_ViewAttachment.Enabled(me.Document().HasContent());

        cmd_UploadDocument = me.getCommand('UploadDocument');
        cmd_UploadDocument.Text("Upload"); // to do: localization
        cmd_UploadDocument.Enabled(me.Document().CanUpload() && !me.Document().HasContent() && !me.ReadOnly());

        cmd_InfoDocument = me.getCommand('InfoDocument');
        cmd_InfoDocument.Text("Info");

        me.CanDeleteAttachment = ko.computed(function () {
            return me.Document().CanDelete();
        });
        cmd_DeleteAttachment = me.getCommand('DeleteAttachment');
        cmd_DeleteAttachment.Text("Delete");
        cmd_DeleteAttachment.Enabled(me.CanDeleteAttachment() && !me.ReadOnly());

        me.watchProperty(me.Document.IsVerified, me._afterIsVerifiedChanged, me, false);
    },

    createCommands: function (config) {
        var me = this;

        me.parent(config);

        me.createCommandCategory('Custom', config);
        var cat = me.CommandCategories.Custom.Commands || { commands: [] };

        // add new command
        newCmd = new TS.domain.Command();
        newCmd['Code'] = 'ViewAttachment';
        newCmd['handler'] = '_viewAttachment';
        cat.push(newCmd);

        // add new command
        newCmd = new TS.domain.Command();
        newCmd['Code'] = 'UploadDocument';
        newCmd['handler'] = '_uploadDocument';
        cat.push(newCmd);

        // show detail popup
        newCmd = new TS.domain.Command();
        newCmd['Code'] = 'InfoDocument';
        newCmd['handler'] = '_infoDocument';
        cat.push(newCmd);

        // add new command
        newCmd = new TS.domain.Command();
        newCmd['Code'] = 'DeleteAttachment';
        newCmd['handler'] = '_deleteAttachment';
        cat.push(newCmd);
    },

    _uploadDocument: function () {

        var me = this,
            owner = me.ParentDomain;

        owner.performServerCommand('UploadAttachment', true, { DocumentUID: me.Document().UID() });
    },

    _infoDocument: function () {

        var me = this,
            owner = me.ParentDomain;

        owner.performServerCommand('ViewAttachmentInfo', true, { DocumentUID: me.Document().UID() });
    },


    _viewAttachment: function () {
        var me = this,
            owner = me.ParentDomain;

        owner.performServerCommand('ViewAttachment', true, { DocumentUID: me.Document().UID() });
    },

    _deleteAttachment: function () {
        var me = this,
            owner = me.ParentDomain,
            strings = TS.cultures.current

        TS.MsgBox.confirm(null, strings.list.DeleteSelectedRecords, strings.common.Delete, function () {
            owner.performServerCommand('DeleteAttachment', true, { DocumentUID: me.Document().UID() });
        });
    },

    _afterIsVerifiedChanged: function (e) {
        var me = this,
            owner = me.ParentDomain;

        if (e == true) {
            me.Document().CheckedByUserId(owner.CurrentUserId);
            me.Document().CheckedByUserName(owner.CurrentUserName());
            me.Document().CheckedDate = new Date();
        }
        else {
            me.Document().CheckedByUserId=null;
            me.Document().CheckedByUserName = null;
            me.Document().CheckedDate = null;
        }
    }
});